module.exports = __webpack_public_path__ + "static/kartchen_jugendstilhotel-27c165133eede46c7cd063294333474c.png";